/**
 * Wind direction display math (spec 11) — pure, no DOM. Feeds the route
 * forecast's "Vind underveis: 4–9 m/s NV" line (dominant from-direction
 * across samples) and the compass abbreviation shown next to it.
 */

const rad = (d: number): number => (d * Math.PI) / 180;
const deg = (r: number): number => (r * 180) / Math.PI;

/** Norwegian 8-point compass abbreviations, "from"-direction convention. */
const COMPASS_POINTS_NB = ['N', 'NØ', 'Ø', 'SØ', 'S', 'SV', 'V', 'NV'] as const;

/** Nearest 8-point Norwegian compass label for a from-direction in degrees. */
export function windCompassLabel(fromDeg: number): string {
  const normalized = ((fromDeg % 360) + 360) % 360;
  const index = Math.round(normalized / 45) % 8;
  return COMPASS_POINTS_NB[index]!;
}

/**
 * Circular mean of a set of directions (degrees) — the correct way to
 * average angles that wrap at 0/360 (a plain arithmetic mean of e.g. 350°
 * and 10° would wrongly yield 180° instead of 0°). Returns 0 for an empty
 * input.
 */
export function circularMeanDeg(degrees: number[]): number {
  if (degrees.length === 0) return 0;
  let sumSin = 0;
  let sumCos = 0;
  for (const d of degrees) {
    sumSin += Math.sin(rad(d));
    sumCos += Math.cos(rad(d));
  }
  const mean = deg(Math.atan2(sumSin, sumCos));
  return ((mean % 360) + 360) % 360;
}
